// extracted by mini-css-extract-plugin
module.exports = {"numbers":"Numbers_numbers__KyWw8","numbers__item":"Numbers_numbers__item__LQl7M","numbers__link":"Numbers_numbers__link__O5icl"};